import { render, staticRenderFns } from "./QuestionnaireList.vue?vue&type=template&id=181ac792&scoped=true"
import script from "./QuestionnaireList.vue?vue&type=script&lang=js"
export * from "./QuestionnaireList.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireList.vue?vue&type=style&index=0&id=181ac792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ac792",
  null
  
)

export default component.exports